import {initElements} from "../define/shared"

export default function initDiscountBlock() {
    initElements(".ph-block.discount", block => {

        const close = block.querySelector('.closeBtn')

        close.addEventListener('click', () => {
            block.classList.add('is-closed')
        })
    })
}
